// @ts-nocheck
import { linkStyles } from "@store/Themes/common/mixins/link";
import common from "@store/Themes/common/styleguide/components/breadcrumbs";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

const breadcrumbs: Styleguide["breadcrumbs"] = {
    defaultProps: {
        ...common?.defaultProps,
        typographyProps: {
            ...common?.defaultProps?.typographyProps,
            color: "secondary",
        },
        css: css`
            ${common?.defaultProps?.css}

            a {
                ${linkStyles("inherit", "inherit", false, true)}
                font-weight: ${({ theme }) => theme.design.typography.weight.base};
            }

            > span:last-child {
                font-weight: ${x => x.theme.design.typography.weight.bold};
            }
        `,
    },
};

export default breadcrumbs;
